module.exports = __webpack_public_path__ + "static/media/sample-kit.498cd731.png";